// extracted by mini-css-extract-plugin
export default {"vertical-icon":"AccountRowItem_vertical-icon__Lao6d"};